function ShowMoreProjectsCarousel() {
  if ($(".show-more-project-carousel").length) {
    $('.show-more-project-carousel').carousel({
      interval: 3000
    });
  }
}

export default ShowMoreProjectsCarousel;
